import React, { useEffect, useState, useContext, useRef } from "react";
import { useSiteConfig } from "../context/SiteConfigContext";
import { Link, useNavigate } from "react-router-dom";
import CartCanvas from "../pages/canvas/CartCanvas";
import Auth from "../utils/AuthUtils";
import { useCart } from "../context/CartContext";
import { CategoryContext } from "../context/CategoryContext";
import { Search, ShoppingBag, Heart, User, X, ChevronDown, ChevronRight } from "lucide-react"; 
import SearchCanvas from "../pages/canvas/SearchCanvas";
import { Offcanvas } from "react-bootstrap"; // 🌟 Imported React-Bootstrap Offcanvas

function Header() {
  const [searchText, setSearchText] = useState("");
  const [showSearchModal, setShowSearchModal] = useState(false);


 const {
  cartItems,
  showCartCanvas,
  setShowCartCanvas,
} = useCart();
  const { config } = useSiteConfig();
  const isLoggedIn = Auth.getToken();
  const { categories } = useContext(CategoryContext);
  
  const [openMobileMenus, setOpenMobileMenus] = useState({});
  const navigate = useNavigate();

  const headerRef = useRef(null);
  const lastScrollY = useRef(0);
  const ticking = useRef(false);

  useEffect(() => {
    const handleScroll = () => {
      if (ticking.current) return;

      ticking.current = true;
      requestAnimationFrame(() => {
        const currentY = window.scrollY;
        const header = headerRef.current;
        if (!header) { ticking.current = false; return; }

        if (window.innerWidth > 991) {
          if (currentY > 80) header.classList.add("is-sticky");
          else header.classList.remove("is-sticky");

          if (currentY > lastScrollY.current && currentY > 100) {
            header.classList.add("header-hidden");
            header.classList.remove("header-visible");
          } else {
            header.classList.remove("header-hidden");
            header.classList.add("header-visible");
          }
        } else {
          header.classList.remove("is-sticky", "header-hidden");
          header.classList.add("header-visible");
        }

        lastScrollY.current = currentY;
        ticking.current = false;
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleMobileToggle = (e, catId, hasChildren, slugPath) => {
    e.stopPropagation();
    
    if (!hasChildren) {
      closeOffcanvasDirectly();
      navigate(`/categories/${slugPath}`);
      return;
    }

    setOpenMobileMenus(prev => ({
      ...prev,
      [catId]: !prev[catId]
    }));
  };

  const closeOffcanvasDirectly = () => {
    const mobileMenuEl = document.getElementById("mobileMenu");
    if (mobileMenuEl) {
      const windowBootstrap = window.bootstrap;
      if (windowBootstrap?.Offcanvas) {
        const instance = windowBootstrap.Offcanvas.getInstance(mobileMenuEl);
        instance?.hide();
      }
    }
  };

  useEffect(() => {
    setShowSearchModal(false);
    setShowCartCanvas(false); // 🌟 Automatically closes cart on route changes
  }, [window.location.pathname]);

  if (!config) return null;

  return (
    <>
      <div className="wrapper home-six-wrapper">
        <header ref={headerRef} className="header-area header-default header-style4 header-transparent sticky-header position-relative header-visible">
          <div className="container-fluid">
            <div className="row row-gutter-0 align-items-center">
              <div className="col-12">
                
                <div className="header-align">
                  {/* LEFT: Mobile Hamburger Trigger */}
                  <button 
                    className="btn-menu custom-hamburger-trigger"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#mobileMenu"
                    style={{ background: 'none', border: 'none', padding: 0 }}
                  >
                    <div className="hamburger-box">
                      <span className="hamburger-bar bar-1"></span>
                      <span className="hamburger-bar bar-2"></span>
                      <span className="hamburger-bar bar-3"></span>
                    </div>
                  </button>

                  {/* CENTER: Premium Brand Logo */}
                  <div className="header-logo-area">
                    <Link to="/">
                      <img 
                        className="logo-main" 
                        src={config?.logo || "https://theorangeapes.com/frontend/img/logo.webp"} 
                        alt="Logo" 
                      />
                    </Link>
                  </div>

                  {/* RIGHT: Action Trigger Icons */}
                  <div className="header-action-container d-flex align-items-center">
                    <button 
                      className="btn-search-icon" 
                      onClick={() => setShowSearchModal(!showSearchModal)}
                      aria-label="Toggle Search"
                    >
                      {showSearchModal ? <X size={22} color="#000" /> : <Search size={22} color="#000" />}
                    </button>

                    {/* 🌟 FIX: Removed data-bs tags, replaced with native React onClick */}
                    <button 
                      className="btn-cart-icon"
                      onClick={() => setShowCartCanvas(true)}
                    >
                      <span className="cart-count">{cartItems?.length || 0}</span>
                      <ShoppingBag size={22} color="#000" />
                    </button>
                  </div>
                </div>

                {/* BOTTOM LAYOUT ROW: Desktop Navigation Categories Dropdown */}
{/* BOTTOM LAYOUT ROW: Desktop Navigation Categories Dropdown */}
<div className="header-navigation-area-custom d-none d-lg-block">
  <div className="main-menu-split-wrapper ">

    {/* 🌟 LEFT GROUP: HOME + first 4 categories */}
    <ul className="main-menu-custom main-menu-group-left nav">
      <li className="menu-item-level1">
        <Link to="/" className="menu-link-level1">HOME</Link>
      </li>

      {categories && categories.slice(0, 3).map((cat) => (
        <li className="menu-item-level1 dropdown-premium-l1" key={cat._id}>
          <Link to={`/categories/${cat.slugPath}`} className="menu-link-level1">
            {cat.name.toUpperCase()}
            {cat.children?.length > 0 && <ChevronDown size={13} className="ms-1 arrow-icon" />}
          </Link>

          {cat.children && cat.children.length > 0 && (
            <ul className="dropdown-premium-l2">
              {/* 🌟 VIEW ALL — is poori category (Bags etc) ke saare products */}
              <li className="dropdown-item-level2 view-all-l2-item">
                <Link to={`/categories/${cat.slugPath}`} className="menu-link-view-all">
                  View All {cat.name}
                </Link>
              </li>

              {cat.children.map((sub) => (
                <li key={sub._id} className="dropdown-item-level2 dropdown-premium-l2-item">
                  <Link to={`/categories/${sub.slugPath}`} className="menu-link-level2 d-flex justify-content-between align-items-center">
                    <span>{sub.name}</span>
                    {sub.children?.length > 0 && <ChevronRight size={13} className="arrow-icon-right" />}
                  </Link>

                  {sub.children && sub.children.length > 0 && (
                    <ul className="dropdown-premium-l3">
                      {/* 🌟 VIEW ALL — is sub-category ke saare products */}
                      <li className="dropdown-item-level3 view-all-l3-item">
                        <Link to={`/categories/${sub.slugPath}`} className="menu-link-view-all">
                          View All {sub.name}
                        </Link>
                      </li>

                      {sub.children.map((subSub) => (
                        <li key={subSub._id} className="dropdown-item-level3">
                          <Link to={`/categories/${subSub.slugPath}`} className="menu-link-level3">
                            {subSub.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          )}
        </li>
      ))}
    </ul>

    {/* 🌟 RIGHT GROUP: next 4 categories + CONTACT */}
    <ul className="main-menu-custom main-menu-group-right nav">
      {categories && categories.slice(3, 8).map((cat) => (
        <li className="menu-item-level1 dropdown-premium-l1" key={cat._id}>
          <Link to={`/categories/${cat.slugPath}`} className="menu-link-level1">
            {cat.name.toUpperCase()}
            {cat.children?.length > 0 && <ChevronDown size={13} className="ms-1 arrow-icon" />}
          </Link>

          {cat.children && cat.children.length > 0 && (
            <ul className="dropdown-premium-l2">
              {/* 🌟 VIEW ALL */}
              <li className="dropdown-item-level2 view-all-l2-item">
                <Link to={`/categories/${cat.slugPath}`} className="menu-link-view-all">
                  View All {cat.name}
                </Link>
              </li>

              {cat.children.map((sub) => (
                <li key={sub._id} className="dropdown-item-level2 dropdown-premium-l2-item">
                  <Link to={`/categories/${sub.slugPath}`} className="menu-link-level2 d-flex justify-content-between align-items-center">
                    <span>{sub.name}</span>
                    {sub.children?.length > 0 && <ChevronRight size={13} className="arrow-icon-right" />}
                  </Link>

                  {sub.children && sub.children.length > 0 && (
                    <ul className="dropdown-premium-l3">
                      {/* 🌟 VIEW ALL */}
                      <li className="dropdown-item-level3 view-all-l3-item">
                        <Link to={`/categories/${sub.slugPath}`} className="menu-link-view-all">
                          View All {sub.name}
                        </Link>
                      </li>

                      {sub.children.map((subSub) => (
                        <li key={subSub._id} className="dropdown-item-level3">
                          <Link to={`/categories/${subSub.slugPath}`} className="menu-link-level3">
                            {subSub.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          )}
        </li>
      ))}

      <li className="menu-item-level1">
        <Link to="/contact-us" className="menu-link-level1">CONTACT</Link>
      </li>
    </ul>

  </div>
</div>

              </div>
            </div>
          </div>

          <SearchCanvas
            isOpen={showSearchModal}
            searchText={searchText}
            setSearchText={setSearchText}
            onClose={() => setShowSearchModal(false)}
          />
        </header>
      </div>

      {/* 🌟 PERFECT FIX: Replaced HTML data-attribute wrapper with React-Bootstrap Offcanvas */}
      <Offcanvas 
        show={showCartCanvas} 
        onHide={() => setShowCartCanvas(false)} 
        placement="end"
        className="custom-cart-offcanvas"
      >
        <CartCanvas onHide={() => setShowCartCanvas(false)} />
      </Offcanvas>

      {/* MOBILE HAMBURGER SIDEBAR CANVAS */}
      <div className="offcanvas offcanvas-start canvas-mb premium-sidebar-canvas" id="mobileMenu">
        <div className="sidebar-luxury-header d-flex justify-content-between align-items-center">
          <div className="user-welcome-badge d-flex align-items-center gap-2"></div>
          <button className="close-sidebar-btn" data-bs-dismiss="offcanvas" aria-label="Close">
            <X size={22} color="#000" />
          </button>
        </div>

        <div className="mb-canvas-content">
          <div className="mb-body">
            <div className="sidebar-account-grid mt-2">
              <Link to={isLoggedIn ? "/users/dashboard" : "/users/login"} className="account-grid-item" onClick={closeOffcanvasDirectly}>
                <User size={20} />
                <span>{isLoggedIn ? "Dashboard" : "Login / Register"}</span>
              </Link>
              <Link to="/wishlist" className="account-grid-item" onClick={closeOffcanvasDirectly}>
                <Heart size={20} />
                <span>My Wishlist</span>
              </Link>
            </div>

            <div className="mb-content-top">
              <div className="sidebar-section-title">SHOP WITH ORANGEAPES</div>
              <ul className="nav-ul-mb">
                <li className="nav-mb-item">
                  <Link to="/" className="mb-menu-link" onClick={closeOffcanvasDirectly}>HOME</Link>
                </li>

                {categories && categories.map((cat) => {
                  const hasSub = cat.children && cat.children.length > 0;
                  return (
                    <li className="nav-mb-item" key={cat._id}>
                      <div className="mb-menu-link d-flex justify-content-between align-items-center">
                        <Link 
                          to={`/categories/${cat.slugPath}`} 
                          className="mb-menu-text-link flex-grow-1"
                          onClick={closeOffcanvasDirectly}
                          style={{ color: 'inherit', textDecoration: 'none' }}
                        >
                          {cat.name.toUpperCase()}
                        </Link>

                        {hasSub && (
                          <span 
                            className="accordion-plus-minus-trigger px-3 py-2"
                            onClick={(e) => handleMobileToggle(e, cat._id, true, cat.slugPath)}
                            style={{ cursor: "pointer" }}
                          >
                            <span className="accordion-plus-minus">{openMobileMenus[cat._id] ? "—" : "+"}</span>
                          </span>
                        )}
                      </div>
                      
                      {hasSub && openMobileMenus[cat._id] && (
                        <div className="dropdown-menu-mb-wrapper" style={{ paddingLeft: "15px" }}>
                          {cat.children.map((sub) => {
                            const hasSubSub = sub.children && sub.children.length > 0;
                            return (
                              <div key={sub._id} className="mb-sub-cat-wrapper">
                                <div className="dropdown-item-mb d-flex justify-content-between align-items-center py-2">
                                  <Link 
                                    to={`/categories/${sub.slugPath}`}
                                    className="mb-sub-text-link flex-grow-1"
                                    onClick={closeOffcanvasDirectly}
                                    style={{ color: 'inherit', textDecoration: 'none', fontWeight: hasSubSub ? "500" : "normal" }}
                                  >
                                    {sub.name}
                                  </Link>

                                  {hasSubSub && (
                                    <span 
                                      className="accordion-plus-minus-trigger px-3"
                                      onClick={(e) => handleMobileToggle(e, sub._id, true, sub.slugPath)}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <span className="accordion-plus-minus" style={{ fontSize: "12px" }}>
                                        {openMobileMenus[sub._id] ? "—" : "+"}
                                      </span>
                                    </span>
                                  )}
                                </div>

                                {hasSubSub && openMobileMenus[sub._id] && (
                                  <div className="dropdown-sub-sub-wrapper" style={{ paddingLeft: "15px", borderLeft: "1px dashed #ddd" }}>
                                    <Link 
                                      to={`/categories/${sub.slugPath}`} 
                                      className="dropdown-item-mb text-secondary small fw-bold"
                                      onClick={closeOffcanvasDirectly}
                                    >
                                      View All {sub.name}
                                    </Link>
                                    {sub.children.map((subSub) => (
                                      <Link 
                                        key={subSub._id} 
                                        to={`/categories/${subSub.slugPath}`} 
                                        className="dropdown-item-mb small text-muted"
                                        onClick={closeOffcanvasDirectly}
                                      >
                                        {subSub.name}
                                      </Link>
                                    ))}
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </li>
                  );
                })}

                <li className="nav-mb-item">
                  <Link to="/contact-us" className="mb-menu-link" onClick={closeOffcanvasDirectly}>CONTACT</Link>
                </li>
              </ul>
            </div>

            <div className="mb-other-content-luxury">
              <div className="mb-contact-title">NEED ASSISTANCE?</div>
              <div className="mb-contact-details">
                <p className="addr-txt">
                  <span>Address: </span>
                  {[config?.address?.addressLine, config?.address?.district, config?.address?.state].filter(Boolean).join(", ")}
                  {config?.address?.pincode ? ` - ${config?.address.pincode}` : ""}
                </p>
                <p>Email: <a href={`mailto:${config?.email}`}>{config?.email}</a></p>
                <p>Phone: <a href={`tel:${config?.phone}`}>{config?.phone}</a></p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}

export default Header;